export const CLINIC = {
  name: "Asmi",
  full: "Asmi Women Health & Infertility Clinic",
  tagline: "Women Health & Infertility Clinic",
  address: "No. Q15 & Q16, 5th Floor, Silvio Heights, St. Inez, Tiswadi, North Goa – 403001",
  phone: "+91 93227 43917",
  email: "docshivanijain@gmail.com",
  calendly: "https://calendly.com/docshivanijain/15min",
  specialities: "Obstetrics • Gynaecology • IUI • IVF",
};

export const CLINIC_HOURS = [
  { day: "Monday", time: "4:00 – 6:30 PM" },
  { day: "Tuesday", time: "9:30 AM – 12:30 PM · 4:00 – 6:30 PM" },
  { day: "Wednesday", time: "4:00 – 6:30 PM" },
  { day: "Thursday", time: "9:30 AM – 12:30 PM · 4:00 – 6:30 PM" },
  { day: "Friday", time: "4:00 – 6:30 PM" },
  { day: "Saturday", time: "By appointment only" },
  { day: "Sunday", time: "Closed" },
];

export const SERVICES = [
  { title: "Menstrual Problems", desc: "Irregular, painful or absent periods evaluated and managed with care." },
  { title: "PCOS / PCOD", desc: "Holistic, long-term management of hormonal and metabolic health." },
  { title: "Heavy Menstrual Bleeding", desc: "Modern evaluation and treatment to restore comfort and confidence." },
  { title: "Pre-conception Counselling", desc: "Preparing your body and mind for a healthy pregnancy journey." },
  { title: "Infertility Evaluation", desc: "Thorough, compassionate diagnosis for both partners." },
  { title: "Infertility Treatment (IUI / IVF)", desc: "Advanced reproductive medicine tailored to your story." },
  { title: "Fibroids & Adenomyosis", desc: "Evaluation and treatment with minimally invasive options." },
  { title: "Post-menopausal Bleeding", desc: "Prompt, sensitive assessment and reassurance." },
  { title: "Pap Smears", desc: "Preventive cervical screening for peace of mind." },
  { title: "Family Planning / Contraception", desc: "Personalised guidance for every stage of life." },
  { title: "Antenatal Check-ups", desc: "Nurturing care through every trimester." },
  { title: "Hysteroscopy", desc: "Precise diagnostic and operative uterine procedures." },
  { title: "Laparoscopy", desc: "Keyhole surgery for faster recovery and gentle healing." },
  { title: "Preventive Gynaecology", desc: "Wellness-first care to keep you thriving for years." },
];

export const MANIFESTO = [
  { n: "01", title: "Nurture", body: "Every consultation is unhurried. You are heard, seen and cared for as a whole person — not a diagnosis." },
  { n: "02", title: "Hope", body: "From first questions to new beginnings, we walk beside you with evidence, empathy and unwavering optimism." },
  { n: "03", title: "Serenity", body: "A calm, warm space designed to soften the hardest moments and celebrate the most joyful ones." },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1457342813143-a1ae27448a82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lotus: "https://images.unsplash.com/photo-1560312473-d6e339d91639?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lotusWhite: "https://images.unsplash.com/photo-1592639252926-01f6628980f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  silhouette: "https://images.unsplash.com/photo-1544784179-ae1535e9f013?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  clinic1: "https://images.unsplash.com/photo-1782397132123-0166b524d6bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  clinic2: "https://images.unsplash.com/photo-1685602728726-76e0340cd1fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  waiting: "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const DEFAULT_TESTIMONIALS = [
  { name: "A. Fernandes", location: "Panaji", quote: "Dr. Shivani made me feel calm and understood from the very first visit. Her care changed my journey completely.", rating: 5 },
  { name: "S. Naik", location: "Mapusa", quote: "Warm, patient and incredibly knowledgeable. I finally felt in safe hands after years of uncertainty.", rating: 5 },
  { name: "R. Kamat", location: "Margao", quote: "The clinic feels nothing like a hospital — it's gentle and reassuring. Truly grateful for the support.", rating: 5 },
];
